<template>
  <div class="wrapper">
    <!-- <div class="detail">
      <div class="title" v-if="firstStep">当前绑定手机号：{{phoneNum}}</div>
      <div class="title" >当前绑定手机号：{{phoneNum}}</div>
      <div class="newInput" v-else>
      <div class="newInput">
        <van-field
          required
          v-model="newPhone"
          placeholder="请输入新手机号"
          :rules="[{ required: true, message: '请输入正确手机格式',pattern:phoneReg }]"
        />
      </div>
      <van-field
        v-model="verifyCode"
        required
        type="number"
        center
        clearable
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="sendVerifyCode"
            v-if="!isDisabled"
          >{{content}}</van-button>
          <van-button size="small" type="info" @click="toastWait" v-else>{{content}}</van-button>
        </template>
      </van-field>
    </div>

    <div class="btn-group">
      <van-button type="info" @click="verifyOldPhone" block v-if="firstStep">下一步</van-button>
      <van-button type="info" @click="modifyPhone" block v-else>完成</van-button>
      <van-button type="info" @click="modifyPhone" block >确定</van-button>
    </div>-->

    <h3>修改手机号</h3>
    <p>当前绑定手机号：{{phoneNum}}</p>

    <van-form class="change-phone">
      <van-field
        v-model="newPhone"
        placeholder="请输入新手机号"
        class="userType from-field-phone"
        :rules="[{ required: true, message: '请输入正确手机格式',pattern:phoneReg }]"
      />
      <van-field
        v-model="verifyCode"
        type="number"
        center
        clearable
        class="userType from-field-phone"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="sendVerifyCode"
            v-if="!isDisabled"
          >{{content}}</van-button>
          <van-button size="small" type="info" @click="toastWait" v-else>{{content}}</van-button>
        </template>
      </van-field>
      <div class="from-button">
        <van-button type="info" @click="modifyPhone" :disabled="!newPhone || !verifyCode" block>确定</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup } from "vant";
import { Tag } from "vant";
import { Field } from "vant";
import { sendMessage, compareVerifyCode, modifyUserInfo } from "../../api/user";
import { mapGetters } from "vuex";
Vue.use(Field);
Vue.use(Tag);
Vue.use(Cell);
Vue.use(CellGroup);
import checkAJB from "../../utils/checkAlipayJSBridge.js";
export default {
  data() {
    return {
      firstStep: false,
      phoneNum: "",
      newPhone: "",
      verifyCode: "",
      count: 60,
      content: "发送验证码",
      isDisabled: false,
      timer: null,
      phoneReg: /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/
    };
  },
  created() {
    this.phoneNum = this.$route.params.phoneNum;
  },
  computed: {
    ...mapGetters(["sessionId"])
  },
  methods: {
    toastWait() {
      this.$toast("请" + this.count + "秒后点击获取！");
    },
    sendVerifyCode() {
      let mobiles = "";
      // if (this.firstStep) {
      //   mobiles = this.phoneNum;
      // } else {
      //   mobiles = this.newPhone;
      // }
      mobiles = this.newPhone;
      if (mobiles == "") {
        this.$toast("请输入手机号");
        return;
      }
      sendMessage({
        mobiles: mobiles
      }).then(res => {
        if (res.respCode === "00000000") {
          this.$toast("已发送验证码");
        } else {
          this.$toast(res.respMsg);
        }
      });
      let vm = this;
      // 控制倒计时及按钮是否可以点击
      const TIME_COUNT = 60;
      vm.count = 60;
      vm.leftTime = TIME_COUNT;
      vm.timer = window.setInterval(() => {
        if (vm.count > 0 && vm.count <= TIME_COUNT) {
          // 倒计时时不可点击
          vm.isDisabled = true;
          // 计时秒数
          vm.count--;
          // 更新按钮的文字内容
          vm.content = vm.count + "s后重新获取";
        } else {
          // 倒计时完，可点击
          vm.isDisabled = false;
          // 更新按钮文字内容
          vm.content = "发送验证码";
          // 清空定时器!!!
          clearInterval(vm.timer);
          vm.timer = null;
        }
      }, 1000);
    },
    // verifyOldPhone() {
    //   if (this.verifyCode == "") {
    //     this.$toast("请输入验证码");
    //     return;
    //   }
    //   if (this.phoneNum == "") {
    //     this.$toast("请输入手机号");
    //     return;
    //   }
    //   if (this.verifyCode.length != 6) {
    //     return this.$toast("请输入6位短信验证码");
    //   }
    //   compareVerifyCode({
    //     inMobies: this.phoneNum,
    //     verifyCode: this.verifyCode
    //   }).then(res => {
    //     if (res.respCode === "00000000") {
    //       this.$toast("验证码校验成功");
    //       // 倒计时完，可点击
    //       this.isDisabled = false;
    //       // 更新按钮文字内容
    //       this.content = "发送验证码";
    //       // 清空定时器!!!
    //       clearInterval(this.timer);
    //       this.timer = null;
    //       this.verifyCode = "";

    //       this.firstStep = false;
    //       console.log(this.firstStep, "false");
    //     } else {
    //       this.$toast(res.respMsg);
    //     }
    //   });
    // },
    async modifyPhone() {
      if (this.newPhone == "") {
        this.$toast("请输入新手机号");
        return;
      }
      if (this.verifyCode == "") {
        this.$toast("请输入验证码");
        return;
      }
      if (!this.phoneReg.test(this.newPhone)) {
        return this.$toast("请输入正确的手机号");
      }
      let headers = {
        sgasession: this.sessionId
      };
      let data = {
        newPhone: this.newPhone,
        verifyCode: this.verifyCode
      };
      console.log("dierbu111", data);
      let res = await modifyUserInfo(headers, data);
      console.log("dierbu", res);
      if (res.respCode === "00000000") {
        this.$toast("修改手机号成功");
        this.$store.commit("user/SET_PHONENUM", this.newPhone);
        checkAJB.setUserInfo({
          userInfo: { mobilePhone: this.newPhone }
        });
        this.$router.go(-1);
      } else {
        this.$toast(res.respMsg);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  height: 100vh;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
  // width: 100%;
  // height: 100%;
  // background: #f1f2f3;
  // .detail {
  //   padding: 24px 16px;
  //   .title {
  //     font-size: 14px;
  //     margin: 16px 0;
  //   }
  //   .newInput {
  //     margin-bottom: 8px;
  //   }
  // }
  // .custom-value {
  //   margin-right: 8px;
  // }
  // .btn-group {
  //   padding: 15px;
  // }
  h3 {
    font-size: 0.8rem;
    color: #333333;
    margin-bottom: 5px;
    font-weight: 550;
  }
  p {
    font-size: 0.4rem;
    color: #999999;
    letter-spacing: 1.5px;
    margin-top: 10px;
  }
  .change-phone {
    margin-top: 25%;
  }
    .from-field-phone {
    font-size: 0.4rem;
    padding: 15px 10px;
    line-height: 25px;
    box-sizing: border-box;
  }
  .userType {
    font-size: 0.4rem;
    padding-left: 0;
  }
    .van-cell:not(:last-child)::after {
    border: none;
  }
  .van-cell {
    border-bottom: 0.02667rem solid #ebedf0;
  }
    .from-button {
    width: 100%;
    border-radius: 5px;
    button {
      border-radius: 3px;
      margin-top: 20px;
      height: 50px;
    }
  }
  /deep/ .van-button--disabled {
    background-color: #ebebeb;
    border-color: #ebebeb;
    opacity: 1;
  }
}
</style>